import { render, staticRenderFns } from "./MyKendoGrid.vue?vue&type=template&id=3b092d70&scoped=true&"
import script from "./MyKendoGrid.vue?vue&type=script&lang=js&"
export * from "./MyKendoGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b092d70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b092d70')) {
      api.createRecord('3b092d70', component.options)
    } else {
      api.reload('3b092d70', component.options)
    }
    module.hot.accept("./MyKendoGrid.vue?vue&type=template&id=3b092d70&scoped=true&", function () {
      api.rerender('3b092d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyKendoGrid.vue"
export default component.exports